import api from '../../../api';

export interface UserMessage {
  from: {
    name: string;
    email: string;
  };
  subject: string;
  message: string;
  info: {
    bookTitle?: string;
    code?: string;
    school?: {
      name?: string;
      address?: string;
    };
  };
  gRecaptchaResponse?: string | null;
  technicalInformation: string;
}

export async function postUserMessage(studioGroup: StudioGroup, userMessage: UserMessage): Promise<void> {
  const language = studioGroup === 'ES' ? 'fr' : 'nl';
  await api.post(`studio/support-message?language=${language}&studioGroup=${studioGroup}`, userMessage);
}

export interface LicenseCodeRequest {
  language?: Language;
  studio?: StudioGroup;
  superModuleId: string;
  moduleId: string;
  groupId: string;
  members: string[];
  technicalInfo: string;
}

export async function postRequestLicenseCodes(
  studioGroup: StudioGroup,
  licenseCodeRequest: LicenseCodeRequest,
): Promise<void> {
  const language = studioGroup === 'ES' ? 'fr' : 'nl';
  await api.post('studio/support/request-license-codes', {
    ...licenseCodeRequest,
    language,
    studio: studioGroup,
  });
}
